<template lang="pug">
div
  v-card.pa-6.mt-4.round-xl(outlined)
    credit-alert(:credit="creditBalance" :title="$t('reload_now_to_send_message')" :showTitle="true" titleFont="heading-6" descFont="text-xs" buttonSize="button-sm")

    div.text-lg.font-medium.basic700--text {{ $t('review_automation') }}
    div.text-sm.font-normal.basic600--text {{ $t('review_automation_description') }}

    div.text-md.font-medium.basic700--text.mt-6 {{ $t('review_automation_sending_type_label') }}
    v-form(ref="form")
      v-radio-group.my-2(v-model="sendingTypeSelection")
        v-radio(value="automatic" color="basic700" )
          template(v-slot:label)
            div.text-md.font-normal.basic700--text {{ $t('review_automation_sending_type_automatic_label') }}
        v-radio(value="manual" color="basic700")
          template(v-slot:label)
            div.text-md.font-normal.basic700--text {{ $t('review_automation_sending_type_manual_label') }}

      template(v-if="sendingTypeSelection === 'automatic'")
        div.text-md.font-medium.basic700--text.mt-4 {{ $t('review_automation_sending_method_label') }}
        v-radio-group.my-2(v-model="methodSelection" :rules="sendingTypeSelection === 'automatic' ? rules.not_empty : []")
          v-radio(value="sms" color="basic700" )
            template(v-slot:label)
              div.text-md.font-normal.basic700--text {{ $t('review_automation_sending_method_sms') }}
          v-radio(value="email" color="basic700")
            template(v-slot:label)
              div.text-md.font-normal.basic700--text {{ $t('review_automation_sending_method_email') }}
        div.text-md.font-medium.neutral700--text.mt-4 {{ $t('collect_review_after') }}
        div.d-flex.align-center
          div(style="width: 60px")
            v-text-field.text-md.font-normal.mt-2.round-xl.inputText(v-model.number="timeValue" placeholder="3" min="0" type="number" outlined :rules="rules.has_quantity" dense height="48" hide-details)
          div.ml-2(style="width: 200px")
            v-select.text-md.font-normal.mt-2.round-xl(v-model="timeUnit" :items="types" item-text="text" item-value="value" outlined :rules="rules.not_empty_select" dense height="48" hide-details)
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="20" height="20" style="margin-top: 6px" :fill="$colors.basic700")
    //- Save
    div.d-flex.my-6
      v-spacer
      v-btn.button-md(color="neutral700" depressed height="48" dark :loading="isLoading" @click="save") {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'

export default {
  components: {
    CreditAlert,
  },
  data () {
    return {
      isLoading: false,
      sendingTypeSelection: null,
      methodSelection: null,
      timeUnit: 'day',
      timeValue: null,
      types: [
        { text: 'Hour', value: 'hour' },
        { text: 'Day', value: 'day' },
        { text: 'Week', value: 'week' },
      ],
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      }
    }
  },
  mounted () {
    this.mapData()
  },
  watch: {
    sendingTypeSelection(newVal, oldVal) {
      if (newVal === 'manual' && oldVal === 'automatic') {
        this.methodSelection = null;
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      reviewSettings: 'review/getSettings',
    }),
    creditBalance () {
      return this.company.prepaid_credits
    },
    payloadData() {
      let autoSms = false
      let autoEmail = false
      let time_unit = 'day'
      let time_value = null
      if (this.sendingTypeSelection === 'automatic') {
        switch (this.methodSelection) {
          case 'sms':
            autoSms = true
            break;

          case 'email':
            autoEmail = true
            break;
        
          default:
            break;
        }
        
        time_unit = this.timeUnit
        time_value = this.timeValue
        if(this.timeValue == "") {
          time_value =  null
        }
      }
      return {
        auto_send_sms: autoSms,
        auto_send_email: autoEmail,
        auto_send_delay_time_unit : time_unit,
        auto_send_delay_time_value : time_value
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    mapData() {
      const autoSms = this.reviewSettings.auto_send_sms
      const autoEmail = this.reviewSettings.auto_send_email
      this.timeUnit = this.reviewSettings.auto_send_delay_time_unit
      this.timeValue = this.reviewSettings.auto_send_delay_time_value
      const manualType = !autoSms && !autoEmail
      if (manualType) {
        this.sendingTypeSelection = 'manual'
        return
      }
      this.sendingTypeSelection = 'automatic'
      if (autoSms) this.methodSelection = 'sms'
      if (autoEmail) this.methodSelection = 'email'
      this.timeUnit = this.reviewSettings.auto_send_delay_time_unit
      this.timeValue = this.reviewSettings.auto_send_delay_time_value
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      this.$axios.patch(`/reviews/${this.company.slug}`, this.payloadData)
        .then(() => {
          this.$store.commit('review/setSettings', this.payloadData)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
}
</script>

<style scoped>
</style>